import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'connected-react-router';
import { CallbackComponent } from 'redux-oidc';
import userManager from '../utils/userManager';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function Login({ dispatch }) {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() => dispatch(push('/loginredirect'))}
      errorCallback={error => console.log(error)}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
}
Login.propTypes = propTypes;
export default connect()(Login);
